import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { LinearBetslipInfoPopup } from '@frontend/sports/types/components/sitecore';

import { IBetslipInfoMessage } from '../../../common/models';
import { ISystemSlipTypeInfo, SystemKey, SystemModesLinearMOfN } from '../../models';

@Injectable()
export default class SystemBetTypesPopUpInfoService {
    private messages: LinearBetslipInfoPopup;

    constructor(public sitecore: Sitecore) {
        this.messages = this.sitecore.betslip.linearBetslipInfoPopup;
    }

    getPopUpInfoByTypeInfo(systemTypeInfo: ISystemSlipTypeInfo): IBetslipInfoMessage {
        const typeInfoKey = systemTypeInfo.slipType.key.toLowerCase();
        const infoText = this.getPopUpInfoSystemKey(typeInfoKey) || this.getPopUpInfoMOfNType(typeInfoKey) || '';

        return {
            header: systemTypeInfo.typeName,
            infoText,
            closeText: this.sitecore.betslip.linearBetslipInfoPopup.InfoPopupHelpClose,
        };
    }

    private getPopUpInfoMOfNType(key: string): string | undefined {
        switch (key) {
            case SystemModesLinearMOfN.System2of3:
                return this.messages.System2of3;
            case SystemModesLinearMOfN.System2of4:
                return this.messages.System2of4;
            case SystemModesLinearMOfN.System2of5:
                return this.messages.System2of5;
            case SystemModesLinearMOfN.System2of6:
                return this.messages.System2of6;
            case SystemModesLinearMOfN.System2of7:
                return this.messages.System2of7;
            case SystemModesLinearMOfN.System2of8:
                return this.messages.System2of8;
            case SystemModesLinearMOfN.System3of4:
                return this.messages.System3of4;
            case SystemModesLinearMOfN.System3of5:
                return this.messages.System3of5;
            case SystemModesLinearMOfN.System3of6:
                return this.messages.System3of6;
            case SystemModesLinearMOfN.System3of7:
                return this.messages.System3of7;
            case SystemModesLinearMOfN.System3of8:
                return this.messages.System3of8;
            case SystemModesLinearMOfN.System4of5:
                return this.messages.System4of5;
            case SystemModesLinearMOfN.System4of6:
                return this.messages.System4of6;
            case SystemModesLinearMOfN.System4of7:
                return this.messages.System4of7;
            case SystemModesLinearMOfN.System4of8:
                return this.messages.System4of8;
            case SystemModesLinearMOfN.System5of6:
                return this.messages.System5of6;
            case SystemModesLinearMOfN.System5of7:
                return this.messages.System5of7;
            case SystemModesLinearMOfN.System5of8:
                return this.messages.System5of8;
            case SystemModesLinearMOfN.System6of7:
                return this.messages.System6of7;
            case SystemModesLinearMOfN.System6of8:
                return this.messages.System6of8;
            case SystemModesLinearMOfN.System7of8:
                return this.messages.System7of8;
            default:
                return undefined;
        }
    }

    private getPopUpInfoSystemKey(key: string): string | undefined {
        switch (key) {
            case SystemKey.BankerSingles:
                return this.messages.SystemBanker;
            case SystemKey.Canadian:
                return this.messages.Canadian;
            case SystemKey.Goliath:
                return this.messages.Goliath;
            case SystemKey.Heinz:
                return this.messages.Heinz;
            case SystemKey.Lucky15:
                return this.messages.Lucky15;
            case SystemKey.Lucky31:
                return this.messages.Lucky31;
            case SystemKey.Lucky63:
                return this.messages.Lucky63;
            case SystemKey.Patent:
                return this.messages.Patent;
            case SystemKey.SuperHeinz:
                return this.messages.Superheinz;
            case SystemKey.Trixie:
                return this.messages.Trixie;
            case SystemKey.Yankee:
                return this.messages.Yankee;
            default:
                return undefined;
        }
    }
}
